import { gql } from '@apollo/client'

export const QUESTION_POOL_LIST_QUERY = gql`
    query QuestionPoolList {
        questionPools {
            _id
            name
            isActive
            questions {
                text
                category
            }
        }
    }
`

export const QUERY_QUESTION_POOL_DETAIL = gql`
    query QuestionPoolDetails($_id: ID!) {
        questionPool(_id: $_id) {
            name
            questions {
                text
                category
            }
            isActive
        }
    }
`

export const QUERY_ACTIVE_QUESTION_POOL = gql`
    query ActiveQuestionPool {
        activeQuestionPool {
            _id
            name
            questions {
                text
                category
            }
            isActive
        }
    }
`

export const MUTATION_CREATE_QUESTION_POOL = gql`
    mutation QuestionPoolCreate($questionPool: QuestionPoolInput!) {
        createQuestionPool(questionPool: $questionPool)
    }
`

export const MUTATION_UPDATE_QUESTION_POOL = gql`
    mutation QuestionPoolUpdate($_id: ID!, $questionPool: QuestionPoolInput!) {
        updateQuestionPool(_id: $_id, questionPool: $questionPool) {
            _id
            name
            isActive
            questions {
                text
                category
            }
        }
    }
`

export const MUTATION_DELETE_QUESTION_POOL = gql`
    mutation QuestionPoolDelete($_id: ID!) {
        deleteQuestionPool(_id: $_id)
    }
`
